import styles from './min-side-status.module.scss';
import { useContext, useState } from 'react';
import { Col, Row } from 'reactstrap';
import PageTitle from '../page-title/page-title';
import { makeRequest, useGetRequestNewHook, useMakeRequestHook } from '../requestUtils';
import { Box, CheckboxLabel, Container, MultiLineTextField, PrimaryButton, SnackBarContext, TextField } from '@frontend-workspace/react-shared-lib';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface MinSideStatusProps {
  statusMessage: string;
  statusMessageEng: string;
  isStatusMessageActive: boolean;
}

export function MinSideStatus() {
  const { isLoading, data } = useGetRequestNewHook("admin/minsideStatus", { message: "", messageEng: "", isActive: false });
  return (
    (!isLoading ?
      <MinSideStatusContent
        statusMessage={data.message}
        statusMessageEng={data.messageEng}
        isStatusMessageActive={data.isActive}
      /> : null)
  );
}

function MinSideStatusContent(props: MinSideStatusProps) {
  const { t } = useTranslation();
  const makeRequest = useMakeRequestHook();
  const { setSnackbarMessage } = useContext(SnackBarContext);
  const [statusMessage, setStatusMessage] = useState<string>(props.statusMessage);
  const [statusMessageEng, setStatusMessageEng] = useState<string>(props.statusMessageEng);
  const [isStatusMessageActive, setIsStatusMessageActive] = useState<boolean>(props.isStatusMessageActive);

  const handleMessageChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => setStatusMessage(event.target.value);
  const handleMessageEndChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => setStatusMessageEng(event.target.value);
  const handleToggleStatusMessage = () => setIsStatusMessageActive(!isStatusMessageActive);

  const handleSaveChanges = () => {
    makeRequest("admin/minsideStatus", "PUT", { message: statusMessage, messageEng: statusMessageEng, isActive: isStatusMessageActive })
      .then(() => setSnackbarMessage({ content: t(" minSideStatus.changeSaved"), type: "success" }));
  };

  return (
    <Container
      className="container-fluid pt-4 px-0"
      maxWidth={false}
      sx={{ paddingBottom: '50px' }}>
      <Row>
        <Col xl={6}>
          <Box
            component="div"
            className="pb-5">
            <PageTitle title={t("app.myPageStatus")} subtitle={`(${t("standard.admin")})`} />
            <div className='mb-3'>
              <CheckboxLabel
                label={t("minSideStatus.activateStatusMessageOnMyPage")}
                checked={isStatusMessageActive}
                onChange={handleToggleStatusMessage}
              />
            </div>
            <div className='mb-3'>
              <MultiLineTextField
                label={t("minSideStatus.statusMessageNorwegian")}
                name='statusMessage'
                minRows={2}
                value={statusMessage}
                onChange={handleMessageChange}
                fullWidth
              />
            </div>
            <div className='mb-3'>
              <MultiLineTextField
                label={t("minSideStatus.statusMessageEnglish")}
                name='statusMessageEng'
                minRows={2}
                value={statusMessageEng}
                onChange={handleMessageEndChange}
                fullWidth
              />
            </div>
            <div className='mb-3'>
              <PrimaryButton
                variant="contained"
                onClick={handleSaveChanges}>
                {t("minSideStatus.saveStatusMessage")}
              </PrimaryButton>
            </div>
          </Box>
        </Col>
      </Row>
    </Container>
  );
}

export default MinSideStatus;